// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vfr-night-additional-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vfr-night-additional-equipment/vfr-night-additional-equipment.js';

mount([g0]);
